import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { Routes, Route } from 'react-router-dom';
import Cookies from 'universal-cookie';

import { Home } from './pages/home';
import { Editor } from './pages/editor';
import { useAppDispatch, useAppSelector } from './redux/store';
import { SideMenu } from './components/SideMenu';
import { Settings } from './pages/settings';
import { Redirecting } from './pages/redirecting';
import './App.css';
import { COOKIES_KEY } from './constants';
import { setHasCookie } from './redux/slices/authSlice';

// add i18n settings
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    // resources: {},
    // lng: 'zh', // if you're using a language detector, do not define the lng option
    fallbackLng: 'zh',
    detection: {
      order: ['cookie', 'localStorage'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: '/assets/locales/{{lng}}/translation.json',
    },
    react: { useSuspense: false },
  });

function App() {
  // client state
  const showMenu = useAppSelector((state) => state.menu.showMenu);
  const dispatch = useAppDispatch();

  const cookies = new Cookies();
  const jwt = cookies.get(COOKIES_KEY);

  if (jwt != null) {
    dispatch(setHasCookie(true));
  }

  return (
    <div className="App">
      {showMenu ? (
        <SideMenu />
      ) : (
        <Routes>
          <Route index element={<Home />}></Route>
          <Route path={'/auth/:token'} element={<Redirecting />}></Route>
          <Route path={'/add'} element={<Editor />}></Route>
          <Route path={'/edit'} element={<Editor />}></Route>
          <Route path={'/settings'} element={<Settings />}></Route>
        </Routes>
      )}
    </div>
  );
}

export default App;
